import styled from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

export default styled.div`
  color: ${lightGrey3Color};
  font-size: 0.8rem;
  line-height: 1.5rem;
  font-weight: 500;
`;
